export default {
  more: "Дагы",
  freeUser: "Акысыз",
  at: "ат.",
  days: "күн",
  serviceUnavailable: "кызмат жеткиликтүү эмес",
  serviceUnavailableCapitalize: "Кызмат жеткиликтүү эмес",
  room: "Кабинет",
  Chief: "Жетекчи",
  Admin: "Администратор",
  Manager: "Менеджер",
  heading: "Билдирүүлөрдү өткөрүп жибебеңиз",
  text: "Эскертмелерди иштетиңиз. Браузер эскертмелерди жөнөтүүгө уруксат сурайт — ага уруксат бериңиз. Мындан кийин кайсы сайтта болсоңуз да, АТИден билдирүүлөр экрандын ылдый жагында пайда болот.",
  btnText: "эскертмелерди иштетүү",
  importantMessagesPluralize: {
    one: "маанилүү билдирүү",
    few: "маанилүү билдирүү",
    many: "маанилүү билдирүүлөр",
    other: "маанилүү билдирүүлөр",
  },
  CoWorker: "Кызматкер",
  score: "Эсеп",
  firman: "Лицензиялар",
  paidFor: "чейин төлөнгөн",
  add: "Кошуу",
  extend: "Узартуу",
  freeAccess: "Сизде акысыз кирүү мүмкүндүгү бар",
  licenseDescr:
    "Сиз акысыз гана унаа жана жүктөрдү көрө аласыз. Барын көрү үчүн лицензияны сатып алыңыз.",
  whatLicensed: "Лицензиялар дагы эмнени берет?",
  selectLicense: "Лицензияны тандоо",
  settings: "Тууралоо",
  recurrentPaymentFailed: "Автоматтык төлөм эсептен чыгарылган жок",
  moreInfo: "Кененирээк",
  pay: "Төлөө",
  conditions: "Шарттар",
  logout: "Чыгуу",
  view: "Көрүү",
  readLater: "Кечирээк окуймун",
  participantsSearch: "АТИ катышуучуларын издөө",
  advancedSearch: "Кеңейтилген издөө",
  advanced: "Кеңейтилген",
  cannotFindFirm: "Биз андай катышуучуну тапкан жокпуз.",
  somethingWentWrong: "Бир жерден ката кетти.",
  somethingWentWrongWithoutDot: "Бир жерден ката кетти",
  byExtendedSearch: "кеңейтилген издөөнү",
  tryUsing: "Колдонууга аракет кылыңыз",
  notificationSettings: "Эскертмелерди тууралоо",
  noNewNotifications: "Жаңы эскертмелер жок",
  viewedNotifications: "Окулган эскертмелер",
  downloadLoadsAndTrucks: "АТИ Жүктөр жана Транспорт жүктөңүз",
  receiveNotifications:
    "Жаңы жүктөр жөнүндө эскертмелерди сиздин телефонуңузга же планшетиңизге алыңыз",
  forAndroid: "Android үчүн",
  forIPhoneIPad: "IPhone жана IPad үчүн",
  markAllAsRead: "Барын окулду деп белгилөө",
  soundOn: "Үнүн күйгүзүү",
  soundMute: "Үнүн өчүрүү",
  loads: "Жүктөр",
  transport: "Транспорт",
  checks: "Текшерүүлөр",
  tenders: "Тендерлер",
  news: "Жаңылыктар",
  forums: "Форумдар",
  docs: "Документтер",
  atiDocs: "АТИ-Документтер",
  tracking: "Мониторинг",
  shipmentTracking: "GPS-мониторинг",
  insurance: "Камсыздандыруу",
  ratingOfParticipants: "Рейтинг",
  contacts: "Байланыштар",
  loans: "Насыялар",
  truckmarket: "Транспорт сатуу",
  yourLoads: "Сиздин жүктөрүңүз",
  addLoad: "Жүктү кошуу",
  searchLoads: "Жүктөрдү табуу",
  load: "Жүк",
  yourTrucks: "Сиздин унааларыңыз",
  addTruck: "Унааны кошуу",
  searchTrucks: "Унааларды табуу",
  truck: "Унааны",
  orders: "Буйрутмалар",
  ordersFromYou: "Сизден келген буйрутмалар",
  ordersToYou: "Сизге келген буйрутмалар",
  ordersToDriver: "Заявка водителю", // !
  vehicleFleet: "Автопарк",
  drivers: "Айдоочулар",
  organizations: "Уюмдар",
  contractors: "Контрагенттер жана контракттар",
  boards: "Аянтчалар",
  yourBoards: "Сиздин аянтчаларыңыз",
  invitationsAndApplications: "Чакыруулар жана билдирмелер",
  youParticipate: "Сиз катышып жатасыз",
  invitations: "Чакыруулар",
  aboutBoards: "Аянтчалар жөнүндө",
  yourTenders: "Сиздин Тендерлериңиз",
  addTenders: "Тендерди кошуу",
  catalogs: "Маалымдамалар",
  directionsLists: "Багыттардын тизмелери",
  companiesList: "Компаниялардын тизмелери",
  requisites: "Сиздин реквизиттериңиз",
  registration: "Каттоо",
  toRegister: "Катталуу",
  login: "кирүү",
  toLogin: "кирүү",
  code: "Код",
  copied: "көчүрүлдү",
  cars: "Унаалар",
  rating: "Рейтинг",
  veh: "Транспорттук каражат",
  guaranteedPayment: "Кепилдик төлөм",
  daysRemaining: ["күн", "күн", "күн"],
  remain: ["калды", "калды"],
  paymentHaveToBeReceived: "Төлөм чейин түшүш керек",
  paymentHadToBeReceived: "Төлөм чейин түшүш керек болчу",
  expired: "мөөнөтү өтүп кеткен",
  avatar: "Аватар",
  accountReplenishment: "Эсепти толуктоо",
  from: "-",
  rub: "руб",
  aMonth: "айына",
  profile_freeAccessTooltip:
    "Эгер сиз унааларды же жүктөрдү көрүү үчүн лицензияны иштетсеңиз, сиз төмөнкүлөрдү кыла аласыз:",
  viewContactsForCarsAndCargoes:
    "Сиз унаа жана жүктордүн байланыштарын көрө аласыз",
  viewPassports:
    "Сын-пикирлер жана дооматтар бар ATI.SU катышуучуларынын паспортторун көрүү",
  Common: "Генерал",
  yourContact: "Сиздин байланыш",
  noLicenseInfo:
    "Учурдагы лицензиялар тууралуу маалымат убактылуу жеткиликтүү эмес",
  shortMonths: {
    0: "үчтүн айынын",
    1: "бирдин айынын",
    2: "жалган куран айынын",
    3: "чын куран айынын",
    4: "бугу айынын",
    5: "кулжа айынын",
    6: "теке айынын",
    7: "баш оона айынын",
    8: "аяк оона айынын",
    9: "тогуздун айынын",
    10: "жетинин айынын",
    11: "бештин айынын",
  },
  januaryGen: "үчтүн айынын",
  februaryGen: "бирдин айынын",
  marchGen: "жалган куран айынын",
  aprilGen: "чын куран айынын",
  mayGen: "бугу айынын",
  juneGen: "кулжа айынын",
  julyGen: "теке айынын",
  augustGen: "баш оона айынын",
  septemberGen: "аяк оона айынын",
  octoberGen: "тогуздун айынын",
  novemberGen: "жетинин айынын",
  decemberGen: "бештин айынын",
  year: "жыл",
  recommendChangingBrowser: "Браузерди өзгөртүүнү сунуштайбыз",
  someSiteFeaturesMayNotWorkInThe: "Сайттын кээбир функциялары",
  thatYouAreUsing: "иштебеши мүмкүн",
  download: "Жүктөө",
  notificationsPluralize: {
    few: "жаңы эскертме",
    many: "жаңы эскертмелер",
    one: "жаңы эскертме",
    other: "жаңы эскермелерди",
  },
  messagesPluralize: {
    oneNumber: "жаңы билдирүү",
    fewNumbers: "жаңы билдирүүнү",
    manyNumbers: "жаңы билдирүүлөрү",
    other: "жаңы билдирүүлөрү",
  },
  remainPluralize: {
    one: "калды",
    few: "калды",
    many: "калды",
    other: "калды",
  },
  daysRemainingPluralize: {
    one: "күн",
    few: "күн",
    many: "күн",
    other: "калды",
  },
  contactsByLicense: {
    one: "кошумча байланыш",
    few: "кошумча байланыштын",
    many: "кошумча байланыштар",
    other: "кошумча байланыштар",
  },
  youHave: "Сизде",
  allRead: "Бары окулду",
  createBoard: "Аянтчаны түзүү",
  unreadNotifications: "Оуклбаган эскертмелер",
  noUnreadNotifications: "Окулбаган эскертмелер жок",
  notifications: "Эскертмелер",
  atiMessenger: "АТИ Мессенджер",
  viewUnread: "Окулбагандарды көрүү",
  readAll: "Барын көрүү",
  viewAll: "Барын окуу",
  automaticPaymentEnabled: "Автотөлөө күйгүзүлгөн",
  clickBackAndTryAgain: "Артка басыңыз жана дагы кайталап көрүңуз.",
  back: "Артка",
  sorrySomethingWentWrong: "Бир жерден ката кетти.",
  loadingError: "Жүктөө катасы.",
  addingNewLicensesWillBeAvailableAfterRenewal:
    "Жаңы лицензияларды кошуу узартылгандан кийин жеткиликтүү болот",
  searchParticipants: "Катышуучуларды издөө",
  stars: "Жылдыздары",
  refresh: "Жаңыртуу",
  loadsOnBoards: "Аятнчалардагы жүктөр",
  sorrySomethingWentWrongPleaseTryAgain:
    "Бир жерден ката кетти, дагы кайталап көрүңүз.",
  participantHasNoPaidLicenses: "Пайдалануучуда төлөнгөн лицензиялары жок",
  anErrorHasOccurredRefreshThePage: "Ката кетти, баракчаны жаңыртыңыз",
  weRecommend: "Биз сунуштайбыз",
  or: "же",
  theSiteWillWorkMoreStable: "Аларда сайт туруктуурак иштейт",
  ICantUseAnotherBrowser: "Мен башка браузерди колдоно албаймын",
  howToInstallAnotherBrowser: "Башка браузерди кантип орнотуу болот",
  tnxForVote: "Добушуңузга рахмат",
  confirm: "Ырастоо",
  resend: "Кайра жөнөтүү",
  sendCode: "Кодду жөнөтүү",
  cancel: "Жокко чыгаруу",
  codeSent: "Код жөнөтүлдү",
  codeSentOnNewEmail: "Жаңы почтаңызга ырастоо коду менен кат жөнөтүлдү",
  resendAgain: "",
  seconds: "секундадан кийин кайра жөнөтүү",
  loanAvailable: "Сизге жеткиликтүү",
  cargoOwnerButtonAvailable: "ATI.SU с нуля",
  youCan: "Сиз",
  unsubscribeFrom: "почта тизмесинен баш тартуу",
  turnPartnerOffers:
    "же эскертме жөндөөлөрүндө өнөктөшдүн бардык сунуштарын өчүрүү",
  inNotificationSettings: "эскертме тескөөлөрүндө",
  youCanUnsubscribeFromPartners:
    "Сиз {{inSettings}} ATI.SU өнөктөштөрүнүн сунуштарынан баш тарта аласыз",

  allServices: "Бардык кызматтар",

  automationHeader: "Жүк ташууларды автоматташтыруу",
  statisticHeader: "Статистика",
  securityHeader: "Коопсуздук",
  comunicationHeader: "Баарлашуу",
  addInstrumentsHeader: "Кошумча инструменттер",
  usefulHeader: "Пайдалуу",

  apiLink: "API ATI.SU",
  apiLinkDescription:
    "Корпоративдик программалык камсыздооңузду ATI.SU кызматтары менен интеграциялаңыз",
  automationLink: "Автоматташтыруу",
  gpsLink: "GPS-мониторинг",
  gpsDescription:
    "Жүк ташуунун статусун жана транспорттун жайгашкан жерин онлайн көзөмөлдөңүз",
  docsLink: "АТИ-Доки (ЭДО)",
  docsDescription: "Электрондук документтерди түзүп өнөктөштөр менен бөлүшүңүз",
  ordersLink: "Буйрутмалар",
  ordersDescription:
    "Жүк ташууларды толугу менен автоматташтырыңыз — өнөктөштөрдү издөөдөн баштап аналитикага чейин",
  boardsLink: "ATI.SU Аянтчалары",
  boardsDescription:
    "Ишеничтүү өнөктөштөр менен иштөө үчүн өзүңүздүн платформаңызды түзүңуз",
  tendersLink: "Тендерлер",
  tendersDescription:
    "Ондогон жана жүздөгөн жүк ташуулар боюнча узак мөөнөттүү келишимдерди түзүңүз",
  auctionLink: "Тооруктар",
  auctionDescription: "Жүккө оптималдуу баасын табыңыз",
  indexLink: "ATI.SU FTL РФ индекси",
  indexDescription:
    "Россия Федерациясынын эң популярдуу багыттары үчүн тарифтердин динамикасы",
  middlePriceLink: "Орточо чендер",
  middlePriceDescription:
    "Россия Федерациясынын миңдеген багыттары үчүн учурдагы актуалдуу чендер RUB/км",
  cargoMapLink: "Жүктөрдүн картасы",
  profitableDestinationsLink: "Пайдалуу багыттар",
  profitableDestinationsDesription: "",
  unlimitedCheckLink: "«Репутация» дан контрагенттерди чексиз текшерүү",
  unlimitedCheckDescription:
    "Коопсуздук сигналы + отчет + Россия Федерациясынын фирмалары үчүн кеңейтилген анализ",
  guaranteePaymentLink: "Ташууну төлөө кепилдиги",
  guaranteePaymentDescription: "",
  checkLink: "ATI.SU текшерүүлөрү",
  checkShortLink: "Текшерүүлөр",
  checkDescription:
    "Жүктөн же төлөмдөн айрылып калбас үчүн, жеке жана юридикалык жакты, транспортту текшериңиз",
  trafficLightLink: "Светофор+",
  trafficLightDescription:
    "Коопсуздук сигналы + Россия жана Казахстандын фирмалары боюнча отчет",
  messengerLink: "АТИ Мессенджер",
  messengerDescription:
    "Жүк ташуу жөнүндө макулдашыңыз, ATI.SU катышуучусуна сүрөт жана документтерди жөнөтүңүз",
  forumsLink: "Форумдар",
  forumsDescription: "Жаңылыктарды талкуулап, тажрыйба жана пикир алмашыңыз",
  realTruckLink: "Активдүү жүк ташуучуларды издөө",
  realTruckDescription:
    "Эгер жүк көпкө чейин кетпесе - ылайыктуу ташуучуну табыңыз",
  distanceCalculatorLink: "Аралыктарды эсептөө",
  distanceCalculatorDescription:
    "Жүк ташуучу унаалар үчүн маршрутту пландаштырыңыз",
  chainsLink: "Жук кошулмалары",
  chainsDescription: "Максималдуу чени менен эң кирешелүү чынжырды куруңуз",
  academyLink: "ATI.SU Академиясы",
  academyDescription: "Логистикалык көйгөйлөрдү натыйжалуу чечүүнү үйрөнүңүз",
  loansLink: "Насыялар",
  loansDescription: "АТИ катышуучуларына өзгөчө шарттар",
  newsLink: "Жаңылыктар",
  newsDescription:
    "Жүк ташуу дүйнөсүндөгү эң маанилүү жаңылыктарды биринчилерден болуп билиңиз",
  partnershipLink: "Рефералдык программа",
  partnershipDescription:
    "Жаңы колдонуучуларды чакырып жана биз менен акча табыңыз",
  ratingLink: "ATI.SU катышуучуларынын рейтинги",
  ratingDescription: "Сиздин аймагыңыздагы мыкты катышуучуларды табыңыз",
  insuranceLink: "Камсыздандыруу",
  insuranceDescription:
    "Бир нече чыкылдатуу менен жүктү же жоопкерчиликти камсыздандырыңыз",
  truckmarketLink: "Транспорт сатуу",
  truckmarketDescription:
    "Транспортту жана спецтехниканы сатыңыз, сатып алыңыз же ижарага алыңыз",
  timeSlots: "Временные окна",
  timeSlotsDescription:
    "Кампанын кезексиз жана штрафсыз натыйжалуу иштешин уюштургула",
  partnersOffers: "Өнөктөштөрдүн атайын сунуштары",
  catalogsLink: "Маалымдамалар",
  ticketsLink: "Кайрылуулар (тикеттер)",
  courierLink: "АТИ Курьер",

  loadsSearch: "Жуктөрдү издөө",
  mainMenu_loads: "Жүктөр",
  trucksSearch: "Унааларды издөө",
  mainMenu_trucks: "Унаалар",

  mainMenu_atiDocs_short: "АТИ-Документтер",

  cargoOwners: "Жүк ээлерине",

  submenu_codeCopied: "Код көчүрүлдү",

  menu_section_loadsAndOrders: "Жүктөр жана буйрутмалар",
  menu_addLoad: "Жүктү кошуу",
  menu_yourLoads: "Сиздин жүктөрүңүз",
  menu_yourTenders: "Сиздин тендерлериңиз",
  menu_addTenders: "Тендерди кошуу",
  menu_yourOrders: "Сизден буйрутмалар",
  menu_reports: "Отчеттор",
  menu_billing: "ATI.SU төлөө",

  menu_section_boards: "Аянтчалар",
  menu_invitations: "Чакыруулар",
  menu_yourBoards: "Сиздин аятнчаларыңыз",
  menu_youParticipate: "Сиз катышып жаьасыз",
  menu_createBoard: "Аянтчаны түзүү",
  menu_boards: "Аянтчалар",

  menu_section_carrierSearch: "Жүк ташуучуларды издөө",
  menu_trucksSearch: "Унаа табуу",
  menu_activeCarriers: "Активдүү жүк ташуучулар",
  menu_rating: "Катышуучулардын рейтинги",
  menu_safetyMemo: "Коопсуздук эскертүүсүү",

  menu_section_catalogs: "Маалыматнаамалар",
  menu_organizations: "Уюмдар",
  menu_partnersAndContracts: "Контрагенттер жана келишимдер",
  menu_yourRequisites: "Сиздин реквизиттериңиз",
  menu_firmLists: "Фирмалардын тизмеси",
  menu_directionLists: "Багыттардын тизмеси",
  menu_catalogs: "Сиздин маалыматнаамаларыңыз",
  menu_drivers: "Айдоочулар",

  carriers: "Жүк ташуучуларга",

  menu_section_trucksAndOrders: "Унаалар жана буйрутмалар",
  menu_addTruck: "Унааны кошуу",
  menu_yourTrucks: "Сиздин унааларыңыз",
  menu_ordersToYou: "Сизге буйрутмалар",

  menu_section_loadsSearch: "Жүктөрдү издөө",
  menu_loadsSearch: "Жүктөрдү издөө",
  menu_cargoChains: "Жүк чынжырлары",
  menu_boardsSearch: "Аянтчалар",

  menu_boardsLoadsSearch: "Аянтчалардагы Жүктөр",

  menu_section_trucksSearch: "Жүк ташуучуну издөө",
  menu_exchange: "ATI.SU биржасы",
  menu_gps: "GPS-мониторинг",

  menu_section_usefull: "Пайдалуу",

  menu_section_yourDocuments: "Сиздин иш кагаздарыңыз",
  menu_section_rouming: "Роуминг",
  menu_section_createDocument: "Иш кагазды түзүү",
  menu_inbox: "Кирүүчү",
  menu_awaitingDecision: "Чечим күтүүдө",
  menu_closing: "ATI.SU-дан жабатындар",
  menu_yourCounterparties: "Сиздин контрагенттериңиз",
  menu_yourCertificates: "Сиздин Электрондук Кол Тамга (ЭКТ) сертификаттарыңыз",
  menu_invoice: "Төлөө үчүн эсеп-фактура",
  menu_applicationAgreement: "Келишим-өтүнмө",
  menu_certificateOfCompletion: "Аткарылган иш тууралуу акт",
  menu_otherDocument: "Башка ишкагазы",

  menu_add_order: "Буйрутма кошуу",

  burger_addLoad: "Жүктү кошуу",
  burger_addTruck: "Унааны кошуу",

  bottom_yourLoad: "Сіздің жүктеріңіз",
  bottom_loads: "Жүктөр",
  bottom_yourTrucks: "Сіздің машиналарыңыз",
  bottom_trucks: "Унаалар",
  bottom_services: "Кызматтар",
  bottom_orders: "Буйрутмалар",
  bottom_profile: "Профиль", // !

  mainMenu_atiDocs: "АТИ-Документтер",

  profile_serviceUnavailable: "Кызмат жеткиликтүү эмес",
  profile_freeUser: "Акысыз",
  profile_atis: "ат.",
  profile_days: "күн",
  profile_yourContact: "Сиздин байланыш",
  profile_refresh: "Жаңыртуу",
  profile_score: "Эсеп",
  profile_room: "Кабинет",
  profile_logout: "Чыгуу",
  profile_freeAccess: "Сизде акысыз кирүү мүмкүндүгү бар",
  profile_freeAccessText:
    "Сиз акысыз гана унаа жана жүктөрдү көрө аласыз. Барын көрү үчүн лицензияны сатып алыңыз.",
  profile_whatsMore: "Лицензиялар дагы эмнени берет?",
  profile_selectLicense: "Лицензияны тандоо",
  profile_fromPerMonth: "Айына 460 руб жогору",
  profile_payBefore: "{{val}} чейин төлөө ",
  profile_guaranteedPayment: "Кепилдик төлөм.",
  profile_remainPluralize: {
    one: "Калды",
    few: "Калды",
    many: "Калды",
    other: "Калды",
  },
  profile_daysRemainingPluralize: {
    one: "күн",
    few: "күн",
    many: "күн",
    other: "күн",
  },
  profile_conditions: "Шарттар",
  profile_pay: "Төлөө",
  profile_settings: "Тууралоо",
  profile_automaticPaymentEnabled: "Автотөлөм иштетилген",
  profile_paidFor: "{{val}}чейин төлөнгөн ",
  profile_addingNewLicenses: "Жаңы лицензияларды кошуу",
  profile_WillBeAvailableAfterRenewal: "узартылгандан кийин жеткиликтүү болот",
  profile_add_new: "Лицензияны кошуу",
  profile_extend: "Узартуу",
  profile_add: "Кошуу",
  profile_recurrentPaymentFailed: "Автоматтык төлөм эсептен чыгарылган жок",
  profile_code: "Код",

  search_participantsSearch: "Катышуучуларын издөө",
  search_atiParticipantsSearch: "ATI.SU катышуучуларын издөө",
  search_advancedSearch: "Кеңейтилген издөө",
  search_advanced: "Кеңейтилген",
  search_phoneAndEmailRestriction:
    "Телефондун номуру жана башка байланыш маалымдары боюнча издөө акы төлөөчү катышуучуларга гана жеткиликтүү.",
  search_pricesAndRates: "Баалар жана тарифтер",

  nps_recomendChance:
    "Кандай ыктымалдуулук менен досторуңузга ATI.SU сайтын сунуштайсыз?",
  nps_errorTryAgain:
    "Дагы бир жолу аракет кылып көрүңүз. Отчет жөнөтүлүп жатканда ката кетти.",
  nps_rateNoRecommend: "эч убакта сунуштабаймын",
  nps_rateRecommend: "сөзсүз сунуштаймын",
  nps_thanksForRate: "жообуңузга рахмат ({{val}} дон 10)",
  nps_commentYourAnswer: "Жоопко комментарий бериңиз",
  nps_send: "Жөнөтүү",
  nps_tryAgain: "Дагы бир жолу аракет кылып көрүңүз.",
  nps_errorWhileSending: "Отчет жөнөтүлүп жатканда ката кетти.",
  nps_answerSended: "Жооп жөнөтүлдү. Сурамжылоого катышканыңыз үчүн рахмат",
  nps_youAlreadyVoted:
    "Сиз буга чейин добуш бергенсиз. Сурамжылоого катышканыңыз үчүн рахмат",

  security_header: "Сиздин оюңузча ATI.SU аркылуу иштөө канчалык коопсуз?",
  security_rateNoRecommend: "таптакыр кооптуу",
  security_rateRecommend: "таптакыр коопсуз",
  security_headerSuccess: "Жообуңузга рахмат",
  security_headerDescription: "Кааласаңыз, сын-пикир калтырсаңыз болот",

  outdated_outdatedBrowserTitle: "Сиздин браузер каталар менен иштеши мүмкүн",
  outdated_ieWasFound:
    "Браузериңиз эскирген. ATI.SU биржасы катасыз иштеши үчүн сунушталган браузерлердин бирин орнотуңуз:",
  outdated_outdatedBrowserWasFound:
    "Сиздин браузердин версиясы эскирип калган. ATI.SU биржасы катасыз иштеши үчүн браузерди жаңыртыңыз",
  outdated_update: "Жаңыртуу",
  outdated_remindLater: "Кечирээк эскертүү",
  outdated_howToUpdate: "Браузерли кантип жаңыртат",
  outdated_howToInstallAnotherBrowser: "Браущерди кантип орнотот",

  refresh_attemptsLimitError:
    "Превышено кол-во обновлений, повторите через 5 минут", // !
  notification_unsubscribePartnerText:
    "Сиз бул {{val1}} же {{val2}} биздин өнөктөштөрдүн бардык сунуштарын өчүрө аласыз",
  notification_unsubscribePartnerATISU:
    "ATI.SU өнөктөшүнүн почта тизмесинен баш тарта аласыз",
  notification_notificationsSettings: "эскертме жөндөөлөрүндө",

  feed_checkAll: "Барын окулду деп белгилөө",
  feed_allRead: "Бары окулду",
  feed_showMessegesText: "Мессенджер билдирүүлөрүнүн текстин көрсөтүү",
  feed_groupedMessageCounter: {
    one: "билдирүү",
    few: "билдирүү",
    many: "билдирүүлөр",
    other: "билдирүүлөр",
  },

  mainMenu_analitics: {
    statistika_rynka: "Рыноктун статистикасы",
    servisy_dlya_analitiki: "Аналитика үчүн кызматтар",
    dinamika_rynka: "Рыноктун динамикасы",
    rynok_v_cifrah: "Рынок сандарда",
  },

  menu_analitics_averageRates: "Орточо чендер",
  menu_analitics_cargomap: "Жүктөрдүн картасы",
  menu_analitics_profitdirections: "Пайдалуу багыттар",
  menu_analitics_index: "Индекс",

  /** Это группе строк не нужен перевод */
  languageInformer_title: "Выберите язык интерфейса",
  languageInformer_description:
    "Вы всегда сможете изменить свой выбор в кабинете или подвале сайта.",
  languageInformer_button: "Сохранить",
  /** Конец группы */
};
